/* AP — fiches produit (lot B). IIFE, zéro dépendance, chargé en defer.
   Tient input[name=id] à jour (unités, logiciel, échelle Template/Pro/Studio, bouton bibliothèque),
   met à jour prix / bouton / URL / barre collante, anime la galerie (scroll-snap, compteur, points,
   miniatures, zoom <dialog>, vidéo externe au clic). Aucun appel /cart : le submit du formulaire
   est intercepté par ap-drawer.js (lot C) ; sans lui, le POST natif vers /cart/add fonctionne. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ap-product]');
  if (!root) return;
  var dataEl = root.querySelector('[data-ap-variants]');
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!data || !data.variants) return;

  function q(s, el) { return (el || root).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }

  var form = q('[data-ap-product-form]');
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var atc = q('[data-ap-atc]');
  var atcLabel = atc ? atc.querySelector('[data-ap-atc-label]') : null;
  var atcSep = atc ? atc.querySelector('[data-ap-atc-sep]') : null;
  var atcPrice = atc ? atc.querySelector('[data-ap-atc-price]') : null;
  var atcNoPrice = !!(atc && atc.hasAttribute('data-ap-atc-noprice'));
  var soon = q('[data-ap-soon]');
  var priceMain = q('[data-ap-price-main] .ap-price__value');
  var sticky = q('[data-ap-sticky]');
  var stickyTitle = q('[data-ap-sticky-title]');
  var stickyVariant = q('[data-ap-sticky-variant]');
  var stickyPrice = q('[data-ap-sticky-price]');
  var stickyBtn = q('[data-ap-sticky-atc]');
  var unitBtns = qa('[data-ap-unit]');
  var softBtns = qa('[data-ap-software]');
  var tiers = qa('[data-ap-tier]');

  var state = {
    unit: data.unit || '',
    software: data.software_option || '',
    tier: null,
    available: !!(atc && !atc.disabled),
    defaultId: String(data.selected_id)
  };
  tiers.forEach(function (t) {
    if (t.getAttribute('aria-checked') === 'true' && t.getAttribute('data-ap-tier') !== 'template') state.tier = t;
  });

  /* ---------- Galerie ---------- */
  var gallery = (function () {
    var g = q('[data-ap-gallery]');
    var track = g && q('[data-ap-track]', g);
    if (!track) return null;
    var slides = qa('[data-ap-slide]', track);
    var n = slides.length;
    if (!n) return null;
    var counter = q('[data-ap-counter]', g);
    var dots = qa('[data-ap-dot]', g);
    var thumbs = qa('[data-ap-thumb]', g);
    var prev = q('[data-ap-prev]', g);
    var next = q('[data-ap-next]', g);
    var index = 0, raf = null;

    function clamp(i) { return Math.max(0, Math.min(n - 1, i)); }
    function setIndex(i) {
      index = clamp(i);
      if (counter) counter.textContent = (index + 1) + ' / ' + n;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
      thumbs.forEach(function (t, k) {
        var a = k === index;
        t.classList.toggle('is-active', a);
        if (a) {
          t.setAttribute('aria-current', 'true');
          var tl = t.parentNode.parentNode;
          var left = t.parentNode.offsetLeft;
          if (left < tl.scrollLeft || left + 64 > tl.scrollLeft + tl.clientWidth) tl.scrollTo({ left: left - 8, behavior: 'smooth' });
        } else {
          t.removeAttribute('aria-current');
        }
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === n - 1;
      qa('video', track).forEach(function (v) {
        if (!v.paused && slides.indexOf(v.closest('[data-ap-slide]')) !== index) v.pause();
      });
    }
    function goTo(i, instant) {
      i = clamp(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      setIndex(i);
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        setIndex(Math.round(track.scrollLeft / (track.clientWidth || 1)));
      });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    g.addEventListener('keydown', function (e) {
      if (e.target.closest('[data-ap-thumb]')) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); thumbs[index] && thumbs[index].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); thumbs[index] && thumbs[index].focus(); }
      }
    });

    /* Vidéo externe : affiche → iframe au clic */
    qa('[data-ap-ext-video]', g).forEach(function (box) {
      var play = box.querySelector('.app-video__play');
      if (!play) return;
      play.addEventListener('click', function (e) {
        e.preventDefault();
        var f = document.createElement('iframe');
        f.src = box.getAttribute('data-ap-video-src');
        f.title = box.getAttribute('data-ap-video-title') || 'Video';
        f.allow = 'autoplay; fullscreen; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        box.innerHTML = '';
        box.appendChild(f);
      });
    });

    /* Zoom */
    var zoom = q('[data-ap-zoom]');
    var zimg = zoom && zoom.querySelector('[data-ap-zoom-img]');
    var zoomIdx = 0;
    function zoomSrc(i) { return slides[i].getAttribute('data-ap-zoom-src'); }
    function showZoom(i) {
      var src = zoomSrc(i);
      if (!src) return;
      zoomIdx = i;
      zimg.src = src;
      var im = slides[i].querySelector('img');
      zimg.alt = im ? im.alt : '';
    }
    function stepZoom(dir) {
      var i = zoomIdx;
      for (var k = 0; k < n; k++) { i = (i + dir + n) % n; if (zoomSrc(i)) { showZoom(i); return; } }
    }
    if (zoom && zimg && typeof zoom.showModal === 'function') {
      slides.forEach(function (s, k) {
        var img = s.querySelector('img.app-gallery__img');
        if (!img || !zoomSrc(k)) return;
        img.addEventListener('click', function () { showZoom(k); zoom.showModal(); updateSticky(); });
      });
      var zc = q('[data-ap-zoom-close]', zoom), zp = q('[data-ap-zoom-prev]', zoom), zn = q('[data-ap-zoom-next]', zoom);
      if (zc) zc.addEventListener('click', function () { zoom.close(); });
      if (zp) zp.addEventListener('click', function () { stepZoom(-1); });
      if (zn) zn.addEventListener('click', function () { stepZoom(1); });
      zoom.addEventListener('click', function (e) { if (e.target === zoom || e.target === zimg) zoom.close(); });
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') stepZoom(1);
        if (e.key === 'ArrowLeft') stepZoom(-1);
      });
      zoom.addEventListener('close', function () { zimg.removeAttribute('src'); goTo(zoomIdx, true); updateSticky(); });
    } else {
      zoom = null;
    }
    setIndex(0);
    return {
      zoom: zoom,
      goToMedia: function (id, instant) {
        for (var k = 0; k < n; k++) {
          if (slides[k].getAttribute('data-media-id') === String(id)) { goTo(k, instant); return; }
        }
      }
    };
  })();

  /* ---------- Variante courante ---------- */
  function tierVariants(t) {
    if (!t) return data.variants;
    if (!t._v) { try { t._v = JSON.parse(t.getAttribute('data-ap-variants')).variants; } catch (e) { t._v = []; } }
    return t._v;
  }
  function pick(list) {
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (state.unit && v.unit && v.unit !== state.unit) continue;
      if (state.software && v.software && v.software !== state.software) continue;
      return v;
    }
    return list[0] || null;
  }
  function fmt(v) { return v.price === 0 ? data.free_label : v.price_fmt; }
  function variantLabel(v) {
    var parts = [];
    var sw = state.tier ? state.tier.getAttribute('data-ap-tier-software') : data.software;
    if (sw && sw !== 'All') parts.push(sw);
    if (v.unit) parts.push(v.unit);
    if (v.software) parts.push(v.software);
    if (state.tier) parts.push(state.tier.getAttribute('data-ap-tier-name'));
    return parts.join(' · ');
  }
  function apply(pushUrl, init) {
    var v = pick(tierVariants(state.tier));
    if (!v) return;
    var available = !!v.available;
    var priceText = fmt(v);
    state.available = available;
    state.defaultId = String(v.id);
    if (idInput) idInput.value = v.id;
    if (atc && atcLabel) {
      atc.disabled = !available;
      atc.setAttribute('data-ap-variant-id', v.id);
      atcLabel.textContent = available ? (atc.getAttribute('data-ap-label') || data.atc_label) : data.soon_label;
      if (atcSep) atcSep.hidden = !available || atcNoPrice;
      if (atcPrice) { atcPrice.textContent = priceText; atcPrice.hidden = !available || atcNoPrice; }
    }
    if (soon) soon.hidden = available;
    if (priceMain) priceMain.textContent = priceText;
    if (stickyPrice) stickyPrice.textContent = priceText;
    if (stickyBtn) stickyBtn.disabled = !available;
    if (stickyTitle) stickyTitle.textContent = state.tier ? state.tier.getAttribute('data-ap-tier-title') : data.title;
    if (stickyVariant) stickyVariant.textContent = variantLabel(v);
    tiers.forEach(function (t) {
      var tv = pick(tierVariants(t));
      var p = t.querySelector('[data-ap-tier-price]');
      if (tv && p) p.textContent = fmt(tv);
    });
    if (pushUrl && !state.tier && window.history && history.replaceState) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u.toString());
      } catch (e) { /* URL non modifiable : sans importance */ }
    }
    if (v.media_id && gallery && !init) gallery.goToMedia(v.media_id);
    updateSticky();
  }

  /* ---------- Unités / logiciel (a[role=button][aria-pressed]) ---------- */
  function bindChoice(btns, attr, key) {
    btns.forEach(function (b) {
      var act = function (e) {
        e.preventDefault();
        state[key] = b.getAttribute(attr);
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        apply(true);
      };
      b.addEventListener('click', act);
      b.addEventListener('keydown', function (e) { if (e.key === ' ') act(e); });
    });
  }
  bindChoice(unitBtns, 'data-ap-unit', 'unit');
  bindChoice(softBtns, 'data-ap-software', 'software');

  /* ---------- Échelle (a[role=radio][aria-checked]) ---------- */
  var enabledTiers = tiers.filter(function (t) { return t.getAttribute('aria-disabled') !== 'true'; });
  tiers.forEach(function (t) {
    var act = function (e) {
      e.preventDefault();
      if (t.getAttribute('aria-disabled') === 'true') return;
      tiers.forEach(function (o) {
        var on = o === t;
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.classList.toggle('is-selected', on);
      });
      state.tier = t.getAttribute('data-ap-tier') === 'template' ? null : t;
      apply(true);
    };
    t.addEventListener('click', act);
    t.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { act(e); return; }
      var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
      if (!d || enabledTiers.length < 2) return;
      e.preventDefault();
      var i = (enabledTiers.indexOf(t) + d + enabledTiers.length) % enabledTiers.length;
      enabledTiers[i].focus();
      enabledTiers[i].click();
    });
  });

  /* ---------- Boutons bibliothèque / pack : input[name=id] avant le submit (capture) ---------- */
  if (form && idInput) {
    form.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-ap-library-add],[data-ap-pack-add]') : null;
      if (!b || !form.contains(b) || b.disabled) return;
      var id = b.getAttribute('data-ap-variant-id');
      if (!id) return;
      idInput.value = id;
      setTimeout(function () { idInput.value = state.defaultId; }, 300);
    }, true);
  }

  /* ---------- Barre collante ---------- */
  var atcVisible = true;
  function updateSticky() {
    if (!sticky) return;
    var show = !atcVisible && state.available && !document.body.classList.contains('ap-drawer-open') && !(gallery && gallery.zoom && gallery.zoom.open);
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      atcVisible = entries[0].isIntersecting;
      updateSticky();
    }, { threshold: 0 }).observe(atc);
    if ('MutationObserver' in window) {
      new MutationObserver(updateSticky).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('ap:drawer:open', updateSticky);
    document.addEventListener('ap:drawer:close', updateSticky);
  }

  apply(false, true);
})();
